<div class="row">
  <div class="col-md-6 mx-auto">
    <div class="card">
      <div class="card-body">
        <h1 class="text-center pb-4 pt-3">
          <span class="text-primary">
            <i class="fa fa-lock"></i> Client Panel
          </span> Register
        </h1>
        <form (submit)="onSubmit()">
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              name="email"
              class="form-control"
              [(ngModel)]="email"
              required>
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              name="password"
              class="form-control"
              [(ngModel)]="password"
              required>
          </div>
          <input type="submit" value="Register" class="btn btn-primary btn-block">
        </form>
      </div>
    </div>
  </div>
</div>
